import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { PlatformLocation } from '@angular/common';
import {TokenService} from '../tokenService.service';

declare var jquery: any;
declare var $: any;

@Component({
  selector: "app-case-practice-list",
  templateUrl: "./case-practice-list.component.html",
  styleUrls: [
    "./case-practice-list.component.css",

  ],
})
export class CasePracticeListComponent implements OnInit, AfterViewInit {
  @Input() practiceList: any;
  @Input() practiceId: any;
  @Input() learningPathId: any;
  @Input() practiceMetaId: any;
  @Output() onGoToExercise = new EventEmitter<any>();

  @Input() status: any;

  finished: boolean;
  learningPath: any;
  finishStatus: boolean;
  learningTour: boolean;
  IsSpecial: boolean;
  goPostSurveyFlag: boolean;
  isOpenClass: number = 0;
  cardId: any;
  chuanjie: any;
  //进入新能力考核标识
  version: number = 0;
  //学习 metaId
  learningPathMetaId: number = 0;
  //学习meta 列表
  learningPathMetas: any;
  isShowQuestionnaire: boolean = false;
  questionnaireInfo: any = null;
  learningPathSubItems: any;
  userId: any;
  approachTheme: any = {};
  currentIndex: number = 0;
  isShowApproach: boolean = false;
  isCustomLock: boolean = false;
  type: string //是否为pc横版

  projectId: string;
  lock: boolean = false;
  isShowToast: boolean = false;
  promptText: string;
  isTencent = false; // 是否腾讯对接
  isHarmonyOS = false; // 是否鸿蒙系统
  get showGoToSurveyBtn(): boolean {
    return this.practiceList.every(item => {
      return item.status === 2;
    })
  }
  constructor(
    private commonService: CommonService,
    private platformLocation: PlatformLocation,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private tokenService: TokenService,
    private router: Router
  ) { }

  ngOnInit() {
    // ---Stephen add 2025-03-07---
    // 添加是否腾讯对接的判断
    this.isTencent = this.commonService.checkAndSetModuleId();
    console.log(this.isTencent, '🐒🐒🐒🐒🐒🐒');
    // -------------------------------------------------------------------
    this.isHarmonyOS = this.commonService.isHarmonyOS();
    console.log(this.practiceMetaId,'_____________________________');
    this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
    localStorage.setItem("moduleId","3");
    this.route.queryParams.subscribe(queryParams => {
      this.type = queryParams['type']
    })
    //特殊场景处理
    this.IsSpecial = false;
    if (this.practiceList.length == 2) {
      if (this.practiceList[0].title == "报告迟交，谁之过?") {
        this.IsSpecial = false;
      }
    }

    this.projectId = localStorage.getItem("projectId")
    let projectmsg = JSON.parse(localStorage.getItem('projectmsg'))
    if (this.projectId && projectmsg) {
      projectmsg.map(item => {
        if (item.type == 4 && item.lockType == 1) {
          this.lock = item.lock;
          this.promptText = `能力考核将于${item.promptTime}开放。`
        }
      })

    }

    this.practiceListInit();
  }

  //初始化情景模拟列表
  practiceListInit(): void {
    this.getLearningTour().then(result => {
      this.userId = result.user_id;
      $('#userIdContainer').val(this.userId);
      this.learningPathMetas = result.learning_path_metas;
    }).then(() => {
      return this.getLearningPathMetaId(this.learningPathId).then(result => {
        console.log(result)
        $('#learningPathMetaIdContainer').val(result.data)
        return this.learningPathMetaId = result.data;
      })
    }).then(() => {
      return this.getPracticeComment(this.learningPathId, { learningPathId: this.learningPathId }).then(result => {
        return this.chuanjie = result.length >= 4 ? result[2].comment : '';
      })
    }).then(() => {
      return this.commonService.getOnceIno(this.commonService.getOnceValue(this.learningPathMetaId, 2)).then(result => {
        return this.finishStatus = result == 1;
      })
    }).then(() => {
      return this.getOrCreateLearningPath(String(this.learningPathMetaId)).then(result => {
        return this.learningPath = result;
      })
    }).then(() => {
      return this.getProgress(this.learningPathMetaId).then(result => {
        //向LMS传递进度
        if(localStorage.getItem("source_env") === "LMS_SCORM"){
          this.commonService.sendDataMessage('type','LMS_LEARN_PROGRESS',result[0].progressList[0].progress,"data");
        }
        return this.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'];
      })
    }).then(() => {
      return this.getUserQuestionnaireInfo(this.learningPathMetaId).then(result => {
        return this.questionnaireInfo = result;
      })
    }).then(() => {
      let temp = true;
      this.commonService.setCustomLockDate(this.learningPath, Date());
      this.learningPathSubItems = this.learningPath.subItems;
      for (let i = 0; i <= this.practiceList.length - 1; i++) {
        if (this.practiceList[i].status != 2) {
          temp = false;
        }
      }
      this.finished = temp;
      setTimeout(() => {
        if (this.finished) {
          //新能力考核 version == 1 时,有能力考核,出现考核按钮,完成按钮不出现
          if (this.version == 1) {
            $("#surveyBtn").fadeIn(200);
          } else {
            $("#nextWrap").show().animate({ bottom: 0 });
          }
        }
      }, 1000);
    }).then(() => {
      this.approachTheme.colorSystem = 'dark';
      this.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
      this.approachTheme.currentIndex = this.currentIndex - 2;
      this.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
      this.approachTheme.btnTxt = '开启能力考核';
      this.isShowQuestionnaire = this.questionnaireInfo && this.questionnaireInfo.length === 0 && this.learningPathSubItems.length === 4 && this.learningPathSubItems.filter(d => d.type === 3)[0].progress === 100 && this.learningPathSubItems.filter(d => d.type === 4)[0].progress !== 100;
    }).then(() => {
      this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(this.learningPathMetaId), 'moduleId': 3, 'breakpointUrl': this.platformLocation['location']['href'], 'projectId': localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null }).then();
      this.isCustomLock = this.learningPathSubItems.length === 4 && this.learningPathSubItems[3].isLock ? this.learningPathSubItems : false;
      this.isShowApproach = true;
    });
  }

  //获取进度
  getProgress(learningPathMetaId: any): Promise<any> {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId),
    }).toPromise();
  }

  //获取learningPath
  getOrCreateLearningPath(learningPathMetaId: any): Promise<any> {
    return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
  }

  ngAfterViewInit() {
    this.commonService.initPage({
      backgroundColor: "white",
    });
  }

  //获取传接
  getPracticeComment(learningPathId: any, data: object): Promise<any> {
    return this.apiService.ajax({
      type: "get",
      url: "/api/concatenation/" + learningPathId,
      data: data
    }).toPromise();
  }

  //获取learningTour
  getLearningTour(): Promise<any> {
    return this.apiService.ajax({
      type: "get",
      url: "/sr/learningtournew",
    }).toPromise();
  }

  //获取learningPathMetaId
  getLearningPathMetaId(learningPathId: any): Promise<any> {
    return this.apiService.ajax({
      'type': 'get',
      'url': '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
    }).toPromise();
  }

  //查询用户相应能力满意度
  getUserQuestionnaireInfo(learningPathMetaId: any): Promise<any> {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
    }).toPromise();
  }

  close() {
    // 只在learningTour里出现，当完成能力是退出进入map
    if ((this.finishStatus || !this.finished) && this.learningTour) {
      let link = ["learning-map", 3];
      this.router.navigate(link);
    } else if (!this.finishStatus && this.finished && this.learningTour) {
      this.commonService.setOnceIno(this.commonService.getOnceValue(this.learningPathMetaId, 2)).subscribe(() => {
        this.router.navigate(["learning-map", 3]);
      });
    } else {
      let learningPathId = null
      let courseId = null
      this.route.queryParams.subscribe(queryParams => {
        learningPathId = queryParams['learningPathId']
        courseId = queryParams['courseId']
      })
      if (learningPathId && courseId) {
        let link = ['course-new', learningPathId, courseId];
        this.router.navigate(link);
      } else {
        let link = ["learning-path", this.learningPathMetaId];
        this.router.navigate(link);
      }
    }
  }

  goToNextStep(i) {
    console.log(i)
    $('#exerciseMetaId').val(this.practiceList[i].exerciseMetaId)
    // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入情景模拟'+(i+1)}).then();
    localStorage.setItem('exerciseMetaId', this.practiceList[i].exerciseMetaId);
    if (this.status == 1 || (this.status != 1 && i == 0)) {
      if (this.practiceList[i].status != 2) {
        if (i == 2) {
          let channel = document.getElementById('resource_route');
          let origin = channel.dataset.src === '' ? this.commonService.getOrigin() : 'https://m.transtalent.cn';
          let params = channel.dataset.src === '' ? '' : '&channelHost=' + this.commonService.getOrigin() + '/yyddi/';
          let originUrl = origin + '/coach/60503/index.html?userId=' + this.userId + '&learningPathMetaId=' + this.learningPathMetaId + '&simulationId=60503&learningPathId=' + this.learningPathId + '&practiceMetaId=' + this.practiceMetaId + '&token=' + this.tokenService.findToken() + '&userIdEncoder=' + this.tokenService.findUserIdEncoder();
          this.platformLocation['location']['href'] = this.isOpenClass === 1 ? originUrl + '&isShowBack=0' : this.type === 'huatek' ? originUrl + '&type=huatek' : originUrl + params;
        } else {
          this.onGoToExercise.emit(i);
        }
      } else {
        if (i == 2) {
          this.getCardIdWithUserId(60503, this.userId).then(result => {
            if (this.type) {
              this.router.navigate(['egret-practice-coach-report', 60503, result.id], { queryParams: { type: 'huatek' } });
            } else {
              this.router.navigate(['egret-practice-coach-report', 60503, result.id]);
            }

          })
        } else {
          let link = [
            "case-practice-report-new",
            this.practiceId,
            this.practiceList[i].id,
            this.learningPathId,
          ];
          if (this.type) {
            this.router.navigate(link, { queryParams: { type: 'huatek' } });
          } else {
            this.router.navigate(link);
          }
        }
      }
    } else {
      $("#mengban").fadeIn();
    }
  }

  goToPostSurvey() {
    if (this.type === 'huatek') {
      this.commonService.sendPostMessage(1, 'goPostSurvey')
      return
    } else {
      if (this.lock) {
        this.showToast();
        return
      }

      this.commonService.learningPortEventLogByCandy({ 'learningPathMetaId': this.learningPathMetaId, 'module': '情景模拟', 'btnName': this.approachTheme.btnTxt, 'userId': localStorage.getItem("userId") }).then();
      this.apiService
        .ajax({
          type: "GET",
          url:
            "/sr/exposeoutapi/setAbilitySession/" +
            this.learningPathMetaId +
            "/4",
        })
        .subscribe((result) => { });
      let link = ["ability-survey", this.learningPathMetaId, 2];
      // let link = ["survey", this.learningPathId, 3, 1];
      // //新能力考核
      // if (this.version == 1) {
      //   link = ["ability-survey", this.learningPathMetaId, 2];
      // }
      this.router.navigate(link);
    }

  }

  showToast() {
    this.isShowToast = true;
    setTimeout(() => {
      this.isShowToast = false;
    }, 2000);
  }

  finish() {
    if (this.finishStatus) {
      return;
    } else {
      this.commonService.setOnceIno(this.commonService.getOnceValue(this.learningPathMetaId, 2)).subscribe();
      let link = ["learning-map"];
      this.router.navigate(link);
    }
  }

  shiyong() {
    let link = ["form", "3"];
    this.router.navigate(link);
  }
  closeTip() {
    $("#mengban").fadeOut();
  }

  getCardIdWithUserId(exerciseMetaId, userId) {
    return this.apiService.ajax({
      'type': 'GET',
      // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/' + exerciseMetaId + '/currentCard?userId=' + userId
      'url': '/sim/v1/simulation/' + exerciseMetaId + '/currentCard'
    }).toPromise();
  }


  closeQuestionnaire() {
    this.isShowQuestionnaire = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-list/case-practice-list.component.ts